import React, { useState } from 'react';
import { Link } from 'gatsby';
import { IoIosSearch, IoIosClose } from 'react-icons/io';
import { DrawerProvider } from '../../components/drawer/drawer-context';
import SocialProfile from '../../components/social-profile/social-profile';
import Menu from './menu';
import Drawer from './drawer';
import SearchContainer from '../search/search';
import HeaderWrapper, {
  HeaderTop,
  TopBarWrapper,
  NavbarWrapper,
  Logo,
  MenuWrapper,
  NavSearchButton,
  NavSearchWrapper,
  SearchCloseButton,
  NavSearchFromWrapper,
  SocialProfileWrapper,
} from './navbar.style';
import LogoImage from '../../images/logo.svg';

import {
  IoLogoFacebook,
  IoLogoTwitter,
  IoLogoInstagram,
  IoLogoLinkedin,
  IoLogoYoutube,
} from 'react-icons/io';

type NavbarProps = {
  className?: string;
};

const MenuItems = [
  {
    label: 'Accueil',
    url: '/',
  },
  {
    label: 'Application',
    url: 'https://www.mylabel.io/#application',
    external: true,
  },
  {
    label: 'Nutri Perso',
    url: 'https://www.mylabel.io/#nutri-perso',
    external: true,
  },
  {
    label: 'Indépendance',
    url: 'https://www.mylabel.io/#sources',
    external: true,
  },
  {
    label: 'Courses en ligne',
    url: 'https://www.mylabel.io/#courses-en-ligne',
    external: true,
  },
  {
    label: 'Retour au site',
    url: 'https://www.mylabel.io',
    external: true,
  },
  {
    label: 'Téléchargez l‘appli',
    url: 'https://www.mylabel.io/dl-app',
    external: true,
  },
];

const SocialLinks = [
  {
    icon: <IoLogoFacebook />,
    url: 'https://www.facebook.com/mylabelcommunity',
    tooltip: '',
  },
  {
    icon: <IoLogoInstagram />,
    url: 'https://www.instagram.com/mylabelapp/',
    tooltip: '',
  },
  {
    icon: <IoLogoTwitter />,
    url: 'https://twitter.com/myLabelApp',
    tooltip: '',
  },
  {
    icon: <IoLogoLinkedin />,
    url: 'https://www.linkedin.com/company/mylabel-app',
    tooltip: '',
  },
  {
    icon: <IoLogoYoutube />,
    url: 'https://www.youtube.com/channel/UCoeNNY4vej_0KZmvodTBCWA',
    tooltip: 'YouTube',
  },
];

const Navbar: React.FunctionComponent<NavbarProps> = ({
  className,
  ...props
}) => {
  const [state, setState] = useState({
    toggle: false,
    search: '',
  });

  const toggleHandle = () => {
    setState({
      ...state,
      toggle: !state.toggle,
    });
  };

  // Add all classs to an array
  const addAllClasses = ['header'];

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  return (
    <HeaderWrapper className={addAllClasses.join(' ')} {...props}>
      <HeaderTop>
        <TopBarWrapper>
          <SocialProfileWrapper>
            <SocialProfile items={SocialLinks} />
          </SocialProfileWrapper>
          <Logo>
            <Link to="https://www.mylabel.io">
              <img src={LogoImage} alt="logo" />
            </Link>
          </Logo>

          <NavSearchButton
            type="button"
            aria-label="search"
            onClick={toggleHandle}
          >
            <IoIosSearch size="23px" />
          </NavSearchButton>

          <DrawerProvider>
            <Drawer items={MenuItems} logo={LogoImage} />
          </DrawerProvider>
        </TopBarWrapper>
        <NavSearchWrapper className={state.toggle === true ? 'expand' : ''}>
          <NavSearchFromWrapper>
            <SearchContainer />
            <SearchCloseButton
              type="submit"
              aria-label="close"
              onClick={toggleHandle}
            >
              <IoIosClose />
            </SearchCloseButton>
          </NavSearchFromWrapper>
        </NavSearchWrapper>
      </HeaderTop>

      {/* <NavbarWrapper className='navbar'>
        <MenuWrapper>
          <Menu items={MenuItems} />
        </MenuWrapper>
      </NavbarWrapper> */}
    </HeaderWrapper>
  );
};

export default Navbar;
